import { render, staticRenderFns } from "./DraggableFilesFieldTreeNode.vue?vue&type=template&id=2e94fccf&"
import script from "./DraggableFilesFieldTreeNode.vue?vue&type=script&lang=js&"
export * from "./DraggableFilesFieldTreeNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTree} from 'quasar'
component.options.components = Object.assign({QTree}, component.options.components || {})
